const PREFIX = 'barbichette-';
/** Sans 0/o, 1/i/l : lisible si on doit dicter le lien. */
const ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789';
const LENGTH = 12;
const ROOM_RE = new RegExp(`^${PREFIX}[${ALPHABET}]{${LENGTH}}$`);
const HASH_RE = /^#\/j\/(.+)$/;

const cryptoBytes = (n: number): Uint8Array => crypto.getRandomValues(new Uint8Array(n));

/** Identifiant de salle PeerJS (≈ 59 bits d'aléa : impossible à deviner). */
export function generateRoomId(randomBytes: (n: number) => Uint8Array = cryptoBytes): string {
  const chars = Array.from(randomBytes(LENGTH), (b) => ALPHABET[b % ALPHABET.length]);
  return PREFIX + chars.join('');
}

export const isValidRoomId = (id: string): boolean => ROOM_RE.test(id);

/** Lien à envoyer à l'ami. L'identifiant est dans le fragment : jamais envoyé au serveur web. */
export function inviteLink(baseUrl: string, roomId: string): string {
  const url = new URL(baseUrl);
  url.hash = `/j/${roomId}`;
  return url.toString();
}

export function parseInvite(hash: string): string | null {
  const id = HASH_RE.exec(hash)?.[1];
  return id !== undefined && isValidRoomId(id) ? id : null;
}
